import { getProfileDesignsAPI } from '@/api/designs';
import { storeDesignsAction } from '../designerReducer';

export const loadDesigns =
  ({ token, activeProfileId }) =>
  async dispatch => {
    const res = await getProfileDesignsAPI({
      profileId: activeProfileId,
      token
    });

    if (!res.error) {
      dispatch(storeDesignsAction(res.data));
    } else {
      // dispatch error
    }
  };
